module.exports = __webpack_public_path__ + "img/social.4003e2e.png";